<template>
  <svg viewBox="10 33 164 117" fill="currentColor" aria-hidden="true">
    <rect x="33" y="33" width="24" height="23" />
    <rect x="33" y="56" width="47" height="24" />
    <rect x="33" y="80" width="118" height="23" />
    <rect x="127" y="103" width="24" height="24" />
    <rect x="80" y="103" width="24" height="24" />
    <rect x="33" y="103" width="24" height="24" />
    <rect x="104" y="127" width="70" height="23" />
    <rect x="10" y="127" width="70" height="23" />
    <rect x="104" y="56" width="47" height="24" />
    <rect x="127" y="33" width="24" height="23" />
  </svg>
</template>
